/**
 * @fileoverview POST handler for the "/companies/:company_id/developers/:developer_id/developer_resend_confirmation" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmationCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmationProps,
  CompaniesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmationResult,
  DeveloperResendConfirmationErrors,
} from "./types";

export const postCompaniesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmation = reactQueryMutationAdapter(
  companiesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmationCacheKeys,
  createMutationFetcherFunctionWithShadowError<DeveloperResendConfirmationErrors>()(
    (
      props: PostCompaniesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmationProps
    ): Promise<CompaniesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmationResult> => {
      return fetch(
        `/companies/${props.companyId}/developers/${props.developerId}/developer_resend_confirmation`,
        "POST",
        props,
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
